import Axios from "axios";

function Event() {}

Event.prototype.list = async function (filter = {}) {
  return await Axios.get("/events", {
    params: filter,
  });
};

Event.prototype.get = async function (id) {
  return await Axios.get("/events/" + id);
};

Event.prototype.createEnrollment = async function (
  eventId,
  teamId,
  kind = "team",
  fields = {},
) {
  return await Axios.post("/events/" + eventId + "/enrollments", {
    entity: teamId,
    kind: kind,
    event: eventId,
    ...fields,
  });
};

Event.prototype.enrollments = async function (eventId, filter = {}) {
  return await Axios.get("/events/" + eventId + "/enrollments", {
    params: filter,
  });
};

Event.prototype.createDraw = async function (eventId, rooms) {
  return await Axios.post("/events/" + eventId + "/draws", { rooms });
};

Event.prototype.getDraw = async function (eventId) {
  return await Axios.get("/events/" + eventId + "/draws");
};

Event.prototype.updateJudges = async function (
  eventId,
  roomNumber,
  judges = [],
) {
  return await Axios.post("/events/" + eventId + "/draws/" + roomNumber, {
    judges,
  });
};

Event.prototype.export = async function (eventId, kind = "member") {
  return await Axios.get("/events/" + eventId + "/export", {
    params: { kind },
  });
};
// Expose Singleton
export default new Event();



// WEBPACK FOOTER //
// ./src/services/Event.js